import {
  EmoticonItem,
  EmoticonItemProps,
  UserItemProps,
  CommandItem,
  CommandItemProps,
} from 'stream-chat-react';
import { emojiIndex } from 'emoji-mart';

/**
 * These commands are lifted from the `ChatAutoComplete` component
 * https://github.com/GetStream/stream-chat-react/blob/master/src/components/ChatAutoComplete/ChatAutoComplete.js
 */

const emojiDataProvider = {
  ':': {
    dataProvider: (q: string, text: string, onReady: (data: object, q: string) => void) => {
      if (q.length === 0 || q.charAt(0).match(/[^a-zA-Z0-9+-]/)) {
        return [];
      }
      const emojis = emojiIndex.search(q) || [];
      const result = emojis.slice(0, 10);

      if (onReady) {
        onReady(result, q);
      }
      return result;
    },
    component: EmoticonItem,
    output: (entity: EmoticonItemProps['entity'] & UserItemProps['entity']) => ({
      key: entity.id,
      text: `${entity.native}`,
      caretPosition: 'next',
    }),
  },
};

const commandsDataProvider = (commands: Array<CommandItemProps['entity']>) => ({
  '/': {
    dataProvider: (q: string, text: string, onReady: (data: object, q: string) => void) => {
      if (text.indexOf('/') !== 0 || !commands) {
        return [];
      }
      const selectedCommands = commands.filter(c => c.name.indexOf(q) !== -1);

      // sort alphabetically unless the you're matching the first char
      selectedCommands.sort((a: CommandItemProps['entity'], b: CommandItemProps['entity']) => {
        let nameA = a.name.toLowerCase();
        let nameB = b.name.toLowerCase();
        if (nameA.indexOf(q) === 0) {
          nameA = `0${nameA}`;
        }
        if (nameB.indexOf(q) === 0) {
          nameB = `0${nameB}`;
        }
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

      const result = selectedCommands.slice(0, 10);

      if (onReady) {
        onReady(result, q);
      }

      return result;
    },
    component: CommandItem,
    output: (entity: CommandItemProps['entity'] & UserItemProps['entity']) => ({
      key: entity.id,
      text: `/${entity.name}`,
      caretPosition: 'next',
    }),
  },
});

export { commandsDataProvider, emojiDataProvider };
